"use client";

import Link from "next/link";

import { twMerge } from "tailwind-merge";
import clsx from "clsx";

function Button({
  text,
  className,
  className2,
  className3,
  onClick = () => {},
  isLink = false,
  link = "",
}) {
  return (
    <>
      {!isLink ? (
        <button
          className={twMerge(
            clsx(
              `px-6 relative group overflow-hidden z-0 py-1 md:px-8 md:py-2 text-lg md:text-2xl rounded hover:brightness-110 active:scale-95 transition-all duration-300 ease-in-out`,
              className
            )
          )}
          onClick={onClick}>
          <div
            className={twMerge(
              clsx(
                `bg-palette-neutral-4 left-0 top-0 rounded-md w-full h-full absolute`,
                className2
              )
            )}></div>
          <div
            className={twMerge(
              clsx(
                `bg-palette-neutral-1 bg-opacity-20 left-0 w-full h-full absolute top-[200%] transition-all duration-300 ease-in-out rounded-t-full rounded-b-md group-hover:top-0 group-hover:rounded-md`,
                className3
              )
            )}></div>
          <span className="relative z-20">{text}</span>
        </button>
      ) : (
        <div
          className={twMerge(
            clsx(
              `px-6 relative group overflow-hidden z-0 py-1 md:px-8 md:py-2 text-lg md:text-2xl rounded hover:brightness-110 active:scale-95 transition-all duration-300 ease-in-out`,
              className
            )
          )}>
          <Link href={link}>
            <div
              className={twMerge(
                clsx(
                  `bg-palette-neutral-4 left-0 top-0 rounded-md w-full h-full absolute`,
                  className2
                )
              )}></div>
            <div
              className={twMerge(
                clsx(
                  `bg-palette-neutral-1 bg-opacity-20 left-0 w-full h-full absolute top-[200%] transition-all duration-300 ease-in-out rounded-t-full rounded-b-md group-hover:top-0 group-hover:rounded-md`,
                  className3
                )
              )}></div>
            <span className="relative z-20">{text}</span>
          </Link>
        </div>
      )}
    </>
  );
}

export default Button;
